import Grid from '@mui/material/Grid';
import { Autocomplete, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';

export const OperationalBuyerFilters = ({ data, selectedFilters, setSelectedFilters }) => {
    // Constant
    const MAX_DROPDOWN_CONTENT = 500;

    // Declaring variables
    const [blockingReasons, setBlockingReasons] = useState(selectedFilters.blockingReasons || []);
    const [plants, setPlants] = useState(selectedFilters.plants || []);
    const [materialGroups, setMaterialGroups] = useState(selectedFilters.materialGroups || []);
    const [purchasingGroups, setPurchasingGroups] = useState(selectedFilters.purchasingGroups || []);
    const [plantsOptions, setPlantsOptions] = useState([]);
    const [purchasingGroupsOptions, setPurchasingGroupsOptions] = useState([]);

    // In order to avoid a too long rendering adding too much useless elements in the dropdown, we slice the collection
    // Only for those that have data collection greater than 2000 lines
    useEffect(() => {
        if (data.Plants !== undefined && plantsOptions.length === 0) {
            setPlantsOptions(data.Plants.slice(0, MAX_DROPDOWN_CONTENT));
        }
        if (data.PurchaseGroup !== undefined && plantsOptions.length === 0) {
            setPurchasingGroupsOptions(data.PurchaseGroup.slice(0, MAX_DROPDOWN_CONTENT));
        }
    }, [data]);

    // filtering the big collection to render only what's needed in the DOM for performances reasons
    const setNewPlantOptions = (v) => {
        setPlantsOptions(
            data.Plants?.filter(
                (p) =>
                    p.PlantCode.toLowerCase().includes(v.toLowerCase()) ||
                    p.PlantName.toLowerCase().includes(v.toLowerCase())
            ).slice(0, MAX_DROPDOWN_CONTENT) ?? []
        );
    };

    const setNewPurchOptions = (v) => {
        setPurchasingGroupsOptions(
            data.PurchaseGroup?.filter(
                (p) =>
                    p.PurchGroup.toLowerCase().includes(v.toLowerCase()) ||
                    p.PurchGroupName.toLowerCase().includes(v.toLowerCase())
            ).slice(0, MAX_DROPDOWN_CONTENT) ?? []
        );
    };

    // Update the selected filters
    useEffect(() => {
        setSelectedFilters({
            companyCodes: selectedFilters.companyCodes,
            agents: selectedFilters.agents,
            role: selectedFilters.role,
            positions: selectedFilters.positions,
            responsibilities: selectedFilters.responsibilities,
            blockingReasons,
            plants,
            materialGroups,
            purchasingGroups,
        });
    }, [blockingReasons, plants, materialGroups, purchasingGroups]);

    // Display the UI
    return (
        <Grid container spacing={2} style={{ paddingTop: '15px' }}>
            <Grid item xs={12}>
                <Autocomplete
                    id="ob-blocking-reasons"
                    options={data.BlockingReasons || []}
                    getOptionLabel={(option) => option?.BlockReason + ' - ' + option?.Description}
                    renderInput={(params) => <TextField {...params} label="Blocking Reason" />}
                    onChange={(e, v) => setBlockingReasons(v)}
                    value={blockingReasons || []}
                    fullWidth
                    multiple
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    id="ob-plants"
                    options={plantsOptions}
                    getOptionLabel={(option) => option?.PlantCode + ' - ' + option?.PlantName}
                    renderInput={(params) => <TextField {...params} label="Plants" />}
                    onInputChange={(e, v) => setNewPlantOptions(v)}
                    onChange={(e, v) => setPlants(v)}
                    value={plants || []}
                    fullWidth
                    multiple
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    id="ob-material-group"
                    options={data.MaterialGroup || []}
                    getOptionLabel={(option) => option?.MatGroup + ' - ' + option?.MatGroupDesc}
                    renderInput={(params) => <TextField {...params} label="Material Group" />}
                    onChange={(e, v) => setMaterialGroups(v)}
                    value={materialGroups || []}
                    fullWidth
                    multiple
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    id="ob-purchasing-group"
                    options={purchasingGroupsOptions}
                    getOptionLabel={(option) => option?.PurchGroup + ' - ' + option?.PurchGroupName}
                    renderInput={(params) => <TextField {...params} label="Purchasing Group" />}
                    onInputChange={(e, v) => setNewPurchOptions(v)}
                    onChange={(e, v) => setPurchasingGroups(v)}
                    value={purchasingGroups || []}
                    fullWidth
                    multiple
                />
            </Grid>
        </Grid>
    );
};
